import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAbacSessionPending } from "../../hooks/useAbacAccess";
import AppShellSkeleton from "../../Layouts/AppShellSkeleton";
import { authSelector } from "../Auth/AuthSlice";
import {
  findFirstAllowedAbacRoute,
  hasNoAllowedAbacPages,
} from "../User/Abac/abacRouteMap";
import NoAccessPage from "./NoAccessPage";


const RedirectToDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, abacPermissions } = useSelector(authSelector);
  const profileData = globalThis.profileData || {};
  const abacPending = useAbacSessionPending();

  const currentPath = String(location.pathname || "").split("?")[0];
  const noAccess = hasNoAllowedAbacPages(
    abacPermissions,
    user,
    profileData
  );
  const fallback = findFirstAllowedAbacRoute(
    abacPermissions,
    user,
    profileData,
    { exclude: currentPath }
  );
  const alreadyOnFallback = Boolean(fallback) && currentPath === fallback;

  useEffect(() => {
    if (abacPending || noAccess || !fallback || alreadyOnFallback) return;
    navigate(fallback, { replace: true });
  }, [abacPending, noAccess, fallback, alreadyOnFallback, navigate]);

  // Still resolving permissions — neutral app shell (not No Access).
  if (abacPending) return <AppShellSkeleton />;

  // Every page toggle off / no landing — full No Access (never empty shell).
  if (noAccess || !fallback || alreadyOnFallback) {
    return <NoAccessPage />;
  }

  return <AppShellSkeleton />;
};

export default RedirectToDashboard;
